import * as React from 'react';
import useEffect from './use_effect';
/**
 * Checks if an element's content has overflow.
 *
 * Element to be checked.
 * @param ref
 *
 * Callback witch fires after the overflow has been checked.
 * @param callback
 *
 * Defines if will check horizontal or vertical overflow.
 * @param isVertical
 */
var useIsOverflow = (ref, callback, isVertical) => {
  var [isOverflow, setIsOverflow] = React.useState(false);
  useEffect(() => {
    var {
      current
    } = ref;
    var trigger = () => {
      var hasOverflow = current ? isVertical ? (current === null || current === void 0 ? void 0 : current.scrollHeight) > (current === null || current === void 0 ? void 0 : current.clientHeight) : (current === null || current === void 0 ? void 0 : current.scrollWidth) > (current === null || current === void 0 ? void 0 : current.clientWidth) : false;
      setIsOverflow(hasOverflow);
      if (callback) callback(hasOverflow);
    };
    if (current) {
      trigger();
    }
  }, [callback, isVertical, ref]);
  return isOverflow;
};
export default useIsOverflow;